// /User/ui_design/src/Components/PatientsFirstSection.js
import React from "react";
import "./PatientsFirst.css"; // ✅ make sure this import exists

export default function PatientsFirstSection() {
  return (
    <section id="patients-first" className="pf-wrap">
      <div className="pf-inner">
        {/* ✅ Chips row */}
        <div className="pf-chips" role="group" aria-label="Project meta">
          <span className="pf-chip">Project — Patients First</span>
          <span className="pf-badge">
            2025 United Nations Youth ChangeMaker • Selected from 2000+ applications
          </span>
        </div>

        {/* Title */}
        <h2 className="pf-title">Patients First</h2>

        {/* Body */}
        <p className="pf-body">
          PatientFirst is a community- and corporate-funded pilot ensuring no cancer patient
          misses treatment because of barriers beyond medicine. Launched with 50+ patients at
          Penn Medicine Princeton Medical Center and supported by 10+ passionate volunteers, it
          tackles transportation and home-support needs head-on. Our goal is simple: zero missed
          appointments, stronger families, and healthier hospitals — creating a model that can
          scale across Penn Medicine and beyond. <a href="#learn" className="pf-link">Learn more →</a>
        </p>

        <p className="pf-body">
          PatientFirst exists to ensure no cancer patient misses treatment because of barriers
          beyond medicine. By tackling transportation and home-support needs, we improve survival
          outcomes, ease caregiver burdens, and strengthen hospitals. Our pilot, launched with 50+
          patients at Penn Medicine Princeton Medical Center, is community- and corporate-funded
          and supported by 10+ passionate volunteers. PatientFirst is proving what’s possible:
          eliminating missed appointments, easing daily burdens, and creating a scalable model that
          can expand across the entire Penn Medicine system to reach underserved patients everywhere.
        </p>

        <h3 className="pf-sub">Our Goals</h3>
        <ul className="pf-goals">
          <li>Zero missed appointments → better survival outcomes</li>
          <li>Relief from home-support burdens → stronger patients and families</li>
          <li>Improved hospital efficiency → healthier communities</li>
        </ul>
      </div>
    </section>
  );
}
